import React, { useEffect, useState } from "react";

const SvgInline = (props) => {
  const [svg, setSvg] = useState(null);
  const [isLoaded, setIsLoaded] = useState(false);
  const [isErrored, setIsErrored] = useState(false);
  const [styles, setStyles] = useState({});

  useEffect(() => {
    fetch(props.url)
      .then((res) => res.text())
      .then(setSvg)
      .catch(setIsErrored)
      .then(() => setIsLoaded(true));
  }, [props.url]);

  useEffect(() => {
    const width = props.style.width.size + props.style.width.unit;
    setStyles({ width: width });
  }, []);

  return <div dangerouslySetInnerHTML={{ __html: svg }} style={styles} />;
};
export default SvgInline;
